<template>
  <b-alert show variant="secondary">
    <h4>When you joined ORBITA-2, you told us:</h4>
    <h4>My angina is <strong>{{text || "** INFORMATION MISSING ** Please call the ORBITA HQ helpline and tell them that your angina description has not yet been set up"}}</strong>.</h4>
  </b-alert>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/MyAnginaIs.vue